import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { translate } from '@/utils/translations'

const Toggle = forwardRef(({
      onClick,
      currentRegion,
      currentRegionFlag,
      show
    },
  ref) => (
    <button
      aria-expanded={show}
      className='toggle-button region-selector'
      data-action='Toggle'
      id='region-selector-toggle'
      onClick={onClick}
      ref={ref}
    >
      <VisuallyHidden>
        {translate('regions.region_selector')}
      </VisuallyHidden>
      <img
        alt={currentRegion}
        src={require(`@/images/${currentRegionFlag}`)}
      />
    </button>
  )
)

export default Toggle

Toggle.propTypes = {
  currentRegion: PropTypes.string.isRequired,
  currentRegionFlag: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}
